import MESSAGES from 'constants/messages';
import { stringMaxLengthIsInvalid } from 'store/utils/validators';
import { Fields, OnCheckIntentName } from '../../types';

const NAME_REGEXP = /^[a-zA-Z]+[a-zA-Z0-9._-]*$/;

type Validate = (
  field: string,
  onCheckIntentName: OnCheckIntentName,
) => Promise<string>;

const validate: Validate = (intentName = '', onCheckIntentName) =>
  new Promise(resolve => {
    if (!intentName || !intentName.match(NAME_REGEXP)) {
      resolve(MESSAGES.INTENTS.NAME.REGEX.CREATE);
    }

    if (stringMaxLengthIsInvalid(intentName)) {
      resolve(MESSAGES.INTENTS.NAME.MAX_LENGTH);
    }

    onCheckIntentName('intentName', intentName)
      .then(() => resolve())
      .catch(({ intentName }: Fields) => resolve(intentName));
  });

export default validate;
